import { securedFetch } from "../../auth/authService";
import { DEVICE_BASELINE_API } from "../../vars";

export function getbaselineRulesById(deviceId) {
    return securedFetch(`${DEVICE_BASELINE_API}?id=${deviceId}`)
        .then(response => response.json())
        .then(baselineRules => {

            return baselineRules;
        })
}
